<template>
	<div id="hobbies">
        <section id="intro"><h1>Loisir</h1></section>
		<div class="separator" style="background-color: #fcfcfc;">
			<div class="seprator__content">
				<h2>Activités</h2>
				<p>
					Toutes les activités auxquelles je m'adonne lorsque j'ai du temps libre.
				</p>
			</div>
		</div>
		<section id="piano">
            <div class="piano__container">
                <div class="piano__video">
					<div class="piano__story">
						<div class="piano__story__content">
							<div class="piano__video__mute">
								<img @click="toggleMute" :src="muteClassButton">
							</div>
							<h2>Le piano</h2>
							<div class="piano__story__description">
								Le piano a toujours été un instrument qui m'a passionné. J'ai commencé à l'apprendre le
								20 août 2019 soit environ {{ estimatePianoPeriod }} mois. <br/>
								Je peux jouer à 60% Nuvola Bianche de Ludovico Einaudi !
							</div>
							<p>Video par: Alexander Flemming</p>
						</div>
					</div>
					<video autoplay loop :muted="muted" playsinline>
						<source src="../assets/piano/nuvola_low.mp4" type="video/mp4">
					</video>
				</div>
            </div>
        </section>
        <section id="drawing">
            <div class="drawing__container">
                <h2>Le dessin</h2>
				<div class="drawing__description">
					<p>
						Le dessin a toujours été l'une de mes activités préférées.
						Il permet d'exprimer sa créativité et et d'entrainer sa capacité à visualiser ses objectifs.
					</p>
				</div>
                <div class="drawing__gallery">
                    <div v-for="drawing in drawingList" :key="drawing" @click="showDrawing(drawing)" class="drawing__item">
						<div class="tap__icon"><img src="../assets/drawing/tap.svg" alt="Tap"></div>
						<img class="drawing__image" :src="getDrawingUrl(drawing)"/>
                    </div>
                </div>
            </div>
        </section>
        <section id="gym"></section>
		<div class="drawing__modal" :class="{hide: showModal}" @click="dismissDrawingModal">
			<div class="drawing__modal__container">
				<img :src="getSelectedDrawingUrl">
				<div class="drawing__modal__caption">
					<div class="drawing__modal__close"><img src="../assets/drawing/close.png" alt="Close button"></div>
					<h2>{{ selectedDrawing.title }}</h2>
					<p class="drawing__modal__description">{{ selectedDrawing.description }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			showModal: false,
			selectedDrawing: {
				title: '',
				description: '',
				fileName: 'archere.jpg'
			},
			muted: true,
			drawingList: [
				{
					title: 'Archere',
					description: 'Ce dessin a été inspiré par la Drow Ranger du jeu Dota 2. Un peu jeune mais meurtrière !',
					fileName: 'archere.jpg'
				},
				{
					title: 'Assassin',
					description: `L'arme a été basé sur un style elfique. Et le reste du dessin à suivi ...`,
					fileName: 'assassin_2.jpg'
				},
				{
					title: 'Assassin 2',
					description: 'Le regard hautain a été le point fort de ce dessin.',
					fileName: 'assassin.jpg'
				},
				{
					title: 'YK',
					description: `L'ombre du visage a été inspiré par une image de The Punisher. Un Punisher asiatique, dont l'identité n'est pas connue ;p`,
					fileName: 'mafia_shadow.jpg'
				},
				{
					title: 'Samurai',
					description: 'Un samourai ... Omae wa ...',
					fileName: 'samurai.jpg'
				}
				// assassin2FullLow: 'assassin_2_full_low_res.jpg',
				// assassin2Full: 'assassin_2_full.jpg',
				// assassinFullLow: 'assassin_full_low_res.jpg',
				// assassinFull: 'assassin_full.jpg',
			]
		}
	},
	computed: {
		muteClassButton () {
			let vol = (this.muted) ? 'vol-off.svg' : 'vol-on.svg'
			return require('../assets/piano/' + vol)
		},
		estimatePianoPeriod () {
			let pianoStart = new Date('08/20/2019')
			let now = Date.now()
			return Math.floor((now - pianoStart) / (1000 * 3600 * 24 * 7 * 4))
		},
		getSelectedDrawingUrl () {
			return require('../assets/drawing/' + this.selectedDrawing.fileName)
		}
	},
	methods: {
		getDrawingUrl (drawing) {
			return require('../assets/drawing/' + drawing.fileName)
		},
		toggleMute () {
			this.muted = !this.muted
		},
		dismissDrawingModal () {
			this.showModal = false
		},
		showDrawing (drawing) {
			this.showModal = true
			this.selectedDrawing = drawing
		}
	}
}
</script>

<style scoped>
    #hobbies {
        min-height: calc(100vh - 10vh);
    }

    #intro {
        height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #f3f3f3;
		background-image: url('../assets/paint.jpg');
		box-shadow: inset 0 0 0 100vmax rgba(150, 150, 150, 0.788);
    }

    #intro h1 {
		/* color: white; */
		letter-spacing: 5px;
		text-transform: uppercase;
		text-align: center;
		margin: 1rem;
	}

	#piano {
		position: relative;
	}

	.piano__video {
		position: relative;
		height: auto;
	}

	.piano__story {
		position: absolute;
		bottom: 5px;
		width: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		color: white;
		z-index: 2;
		padding: 1rem;
	}

	.piano__story h2 {
		margin: 0 0 1rem 0;
	}

	.piano__story__content {
		position: relative;
	}

	.piano__video__mute img {
		position: absolute;
		top: 3px;
		right: 5px;
	}

	.piano__video__mute img {
		background-size: contain;
		cursor: pointer;
		border: 0;
		width: 2rem;
		height: 2rem;
		filter: invert(1);
	}

	.piano__story__content p {
		font-size: 0.7rem;
	}

	.piano__story__description {
		position: relative;
	}

	.piano__video video {
		width: 100%;
		height: auto;
	}

	.drawing__container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.drawing__container h2 {
		margin-top: 4rem;
	}

	.drawing__description {
		margin: 1rem;
		padding: 1rem;
		text-align: justify;
	}

	.drawing__gallery {
		margin: 1rem 5rem;
		-webkit-column-count: 3;
		-webkit-column-gap: 0px;
		-moz-column-count: 3;
		-moz-column-gap: 0px;
		column-count: 3;
		column-gap: 0px;
		line-height: 0;
	}

	.drawing__item {
		position: relative;
		margin: 0.2rem;
	}

	.drawing__image {
		position: relative;
		width: 100%;
		height: auto;
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
		transition: all 0.5s ease-out;
	}

	.drawing__item:hover .drawing__image {
		cursor: pointer;
		transform: scale(1.1);
		z-index: 2;
	}

	.tap__icon {
		display: none;
	}

	.drawing__modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		visibility: hidden;
		opacity: 0;
		background-color: rgba(0, 0, 0, 0.884);
		transition: all 0.5s ease-out;
		z-index: 60;
	}

	.drawing__modal.hide {
		visibility: visible;
		opacity: 1;
	}

	.drawing__modal__container {
		width: 100%;
		height: 100vh;
		display: flex;
		justify-content: center;
		padding: 1rem;
		color: white;
	}

	.drawing__modal__container img {
		display: block;
		max-width: 100%;
		max-height: 100%;
	}

	.drawing__modal__caption {
		position: relative;
		margin: 2rem;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
	}

	.drawing__modal__caption h2,
	.drawing__modal__description {
		width: 50vw;
	}

	.drawing__modal__close {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
	}

	.drawing__modal__close img {
		width: 3rem;
		height: 3rem;
		filter: invert(1);
		margin: auto;
	}

	/* Big screens */

	@media (min-width: 75rem) {
		.drawing__gallery {
			-webkit-column-count: 4;
			-moz-column-count: 4;
			column-count: 4;
		}
	}

	@media (min-width: 95rem) {
	}

	/* Small screens */

	@media (max-width: 60rem) {
		.drawing__gallery {
			margin: 1rem 1.5rem;
			-webkit-column-count: 2;
			-moz-column-count: 2;
			column-count: 2;
		}

		.drawing__modal__caption h2,
		.drawing__modal__description {
			width: 35vw;
		}
	}

	@media (max-width: 40rem) {
		.drawing__gallery {
			margin: 0;
		}

		.piano__video {
			display: flex;
			flex-direction: column-reverse;
		}

		.piano__story {
			position: initial;
		}

		.piano__video__mute img {
			width: 1.5rem;
			height: 1.5rem;
		}

		.tap__icon {
			display: block;
			position: absolute;
			top: 0;
			right: 0;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 0 45px 45px 0;
			border-color: transparent #0000007c transparent transparent;
			z-index: 3;
		}

		.tap__icon img {
			transform: translate(21px, 4px);
			width: 20px;
			height: 20px;
			filter: invert(1);
		}

		.drawing__modal__container {
			width: 60vw;
			justify-content: initial;
		}

		.drawing__modal__container img {
			display: block;
			width: 100%;
			height: auto;
			object-fit: cover;
		}

		.drawing__modal__caption {
			margin: 0 0 0rem 1rem;
		}

		.drawing__modal__caption h2,
		.drawing__modal__description {
			width: 35vw;
		}

		.drawing__modal__close {
			position: initial;
		}

		.drawing__modal__close img {
			width: 2rem;
			height: 2rem;
		}
	}
</style>
